export interface Service {
  id: string
  emoji: string
  title: string
  description: string
  image: string
  imageAlt: string
}

export const services: Service[] = [
  {
    id: 'amarres',
    emoji: '💞',
    title: 'AMARRES Y SITUACIONES SENTIMENTALES',
    description:
      'Prácticas tradicionales relacionadas con situaciones sentimentales, relaciones y vínculos personales.',
    image: 'https://cdn.magicpatterns.com/uploads/iEnDS3VJtbXcMEzz5YjqnG/image.png',
    imageAlt:
      'Pareja abrazada bajo una manta frente al mar al atardecer, como representación temática del servicio',
  },
  {
    id: 'rituales-amor',
    emoji: '🕯️',
    title: 'RITUALES DE AMOR Y PAREJA',
    description:
      'Consultas y rituales tradicionales relacionados con el amor, las relaciones y situaciones de pareja.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ebbdd5ee-476d-4358-9fdd-1fcb19c41390.jpg',
    imageAlt:
      'Hilera de velas encendidas en candelabros de plata sobre un altar de madera oscura con humo de incienso',
  },
  {
    id: 'limpiezas',
    emoji: '🧿',
    title: 'LIMPIEZAS Y PROTECCIÓN ESPIRITUAL',
    description:
      'Prácticas tradicionales relacionadas con limpieza, protección y orientación espiritual.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/a647b7b2-5d96-4a33-90ce-62f7be769b71.jpg',
    imageAlt:
      'Manojo de hierbas humeantes, amuleto de ojo turco, piedras de obsidiana y selenita sobre piedra oscura',
  },
  {
    id: 'sentimentales',
    emoji: '🌈',
    title: 'SITUACIONES SENTIMENTALES',
    description:
      'Consultas relacionadas con relaciones, vínculos personales y situaciones afectivas.',
    image: 'https://cdn.magicpatterns.com/uploads/fB6H6UUhecHpmWTStn5bSF/image.png',
    imageAlt:
      'Dos personas celebrando juntas envueltas en una bandera arcoíris, como representación temática del servicio',
  },
]
